
import Vue from 'vue';
import { RotateClockwise16, RotateClockwiseAlt16 } from '@carbon/icons-vue';
import { useStore as useShapeStore } from '@/stores/v2/shape';
import { mapActions, mapState } from 'pinia';
import { AnnotationShape } from '@/web-components/import-wizard/typings';
import { useStore as useNotificationStore } from '@/stores/v2/notification';
import { useStore as useMirrorStore } from '@/stores/v2/mirror';
import { useStore as useHistoryStore } from '@/stores/v2/history';
import { generateEventPayloadV2 } from '@/utils/generatePriceParamsEventPayload';
import { createStateSnapshot } from '@/utils/historyHelperV2';
import { CvNumberInput, CvIconButton } from '@carbon/vue';
import { useStore as useProductStore } from '@/stores/v2/product';

export default Vue.extend({
  name: 'RotationShapeControls',
  components: {
    RotateClockwise16,
    RotateClockwiseAlt16,
    CvNumberInput,
    CvIconButton,
  },
  data() {
    return {
      RotateClockwise16,
      RotateClockwiseAlt16,
    };
  },

  computed: {
    ...mapState(useShapeStore, ['activeShapeId', 'shapes', 'shapeById']),
    ...mapState(useProductStore, ['isSublimationTechnique']),

    activeShape(): AnnotationShape | undefined {
      return this.shapes.find((shape) => shape.id === this.activeShapeId);
    },

    activeShapeRotation(): number {
      if (this.activeShape) {
        let rotation = ((this.activeShape.rotation as number) * 180) / Math.PI;

        if (rotation >= -90 && rotation < 0) {
          rotation = 360 + rotation;
        }
        return parseInt(rotation.toFixed());
      }
      return 1;
    },
  },

  methods: {
    ...mapActions(useShapeStore, ['transformShape']),
    ...mapActions(useNotificationStore, ['runValidators']),
    ...mapActions(useMirrorStore, ['updateMirrorShape']),
    ...mapActions(useHistoryStore, ['recordHistory']),

    rotateClockwise() {
      var newValue = this.activeShapeRotation + 90;
      if (newValue > 360) {
        newValue = newValue - 360;
      }
      this.transformShape('rotation', newValue);
      this.runValidators();

      const activeShape = this.shapeById(this.activeShapeId);
      if (this.isSublimationTechnique && activeShape && activeShape.isInArea) {
        this.applySublimationConverter(this.activeShapeId);
      }
      if (activeShape) {
        this.updateMirrorShape(activeShape);
      }

      const eventPayload = generateEventPayloadV2();

      this.$emit('wizard:price-params-changed', {
        productPrintPositions: eventPayload,
      });

      const snapshot = createStateSnapshot();
      this.recordHistory(snapshot);
    },
    rotateCounterClockwise() {
      var newValue = this.activeShapeRotation - 90;
      if (newValue < 0) {
        newValue = newValue + 360;
      }
      this.transformShape('rotation', newValue);
      this.runValidators();

      const activeShape = this.shapeById(this.activeShapeId);
      if (this.isSublimationTechnique && activeShape && activeShape.isInArea) {
        this.applySublimationConverter(this.activeShapeId);
      }

      if (activeShape) {
        this.updateMirrorShape(activeShape);
      }

      const eventPayload = generateEventPayloadV2();

      this.$emit('wizard:price-params-changed', {
        productPrintPositions: eventPayload,
      });

      const snapshot = createStateSnapshot();
      this.recordHistory(snapshot);
    },
  },
});
